export default __webpack_public_path__ + "static/media/icon-work.5db8430b.svg";